module.exports = __webpack_public_path__ + "img/galileo_icon1.74ebd1b3.png";